import React from 'react'
import Navbar from '../Component/Navbar'
import PromotedAds from '../Component/PromotedAds';
import Footer from '../Component/Footer';
import BottomAds from '../Component/BottomAds';
import TopAds from "../Component/TopAds";

function PromotedAdsPage() {
  return (
    <div className=''>
       <Navbar />
       <TopAds />
       <PromotedAds />
       <BottomAds />
       <Footer />
    </div>
  )
}

export default PromotedAdsPage;